import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=1e120447&scoped=true&"
import script from "./Instructors.vue?vue&type=script&lang=js&"
export * from "./Instructors.vue?vue&type=script&lang=js&"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=1e120447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e120447",
  null
  
)

export default component.exports